import React, {PropsWithChildren, useState} from "react";
import styles from "./Checkbox.module.scss";
import {isTouchDevice} from "../../../../helpers/deviceInformation";

type ChechboxProps = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  wrapperClassName?: string;
  color?: "green" | "lightgreen" | "blue" | "darkgrey" | "lightgrey";
  disabled?: boolean;
};

const Checkbox: React.FC<PropsWithChildren<ChechboxProps>> = ({
  children,
  checked = false,
  onChange,
  className = "",
  wrapperClassName = "",
  color = "green",
  disabled = false,
}) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={[styles.checkboxWrapper, wrapperClassName, disabled ? "checkbox__disabled" : ""].join(" ")}
      onMouseOver={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        setIsHover(false);
      }}
    >
      <label>
        <input
          type="checkbox"
          checked={checked}
          onChange={(evt) => {
            if (onChange) {
              onChange(evt.target.checked);
            }
          }}
          disabled={disabled}
        />
        <div className={`${styles.checkboxDiv} ${className}`}>
          {checked && (
            <span className={`icon-check${color !== "darkgrey" ? `--${color}` : ""} ${styles.checkboxDivIcon}`} />
          )}
          {!checked && isHover && !isTouchDevice() && (
            <span className={`icon-check--lightgrey ${styles.checkboxDivIcon}`} />
          )}
        </div>
        <div className={styles.childrenWrapper}>{children}</div>
      </label>
    </div>
  );
};

export default Checkbox;
